
import React, { useEffect, useState } from "react";

const ClearApplicationCache = () => {
  const [status, setStatus] = useState("");

  const clearApplicationCache = async () => {
    try {
      // 1. Clear Application Cache Storage
      if ("caches" in window) {
        const cacheNames = await window.caches.keys();

        await Promise.all(
          cacheNames.map((cacheName) =>
            window.caches.delete(cacheName)
          )
        );
      }

      // 2. Unregister Service Workers
      if ("serviceWorker" in navigator) {
        const registrations =
          await navigator.serviceWorker.getRegistrations();

        await Promise.all(
          registrations.map((registration) =>
            registration.unregister()
          )
        );
      }

    //   setStatus("Application cache cleared successfully.");
      console.warn("Application cache cleared successfully.");
    } catch (error) {
      setStatus("Error clearing application cache.");
      console.error("Error clearing application cache:", error);
    }
  };

  useEffect(() => {
    clearApplicationCache();
  }, []);

  return (
    <div>
      {status && <p>{status}</p>}
    </div>
  );
};

export default ClearApplicationCache;
